import { generateRolePermissionTableColumn } from '../../../constants/tableColumns';
import { useRolePermissionContext } from '../../../contexts/RolePermissionProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import MutateRolePermissionAction from './MutateRolePermissionAction';
import RolePermissionTableLegends from './RolePermissionTableLegends';

const ShowAllRolePermissions = () => {
  // integration of context hooks here
  const {
    rolePermissionList,
    rolePermissionTableList,
    isError,
    isLoading,
    isSuccess,
  } = useRolePermissionContext();

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('rolePermissions');

  // rendering show all role permissions section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Role Permissions'
              additionalComponent={<RolePermissionTableLegends />}
            />

            <AcademiaTable
              data={rolePermissionTableList}
              columns={generateRolePermissionTableColumn(
                rolePermissionList.map((permission) => permission.role_name)
              )}
              tableToolbarComponent={
                <MutateRolePermissionAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                  hasUpdatePermission={featureBasedPermissions.includes(
                    'UPDATE'
                  )}
                />
              }
              notFoundMessage='No role permissions found!'
              hasMultipleToolbarComponents
            />
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load role permission data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllRolePermissions;
